import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
	
	template: '',
})
export class SingleSignOnComponent implements OnInit {
	private authService = inject(AuthService);


	constructor() {}

	ngOnInit(): void {
		const url = this.authService.getExternalSigninUrl();
		console.warn(`Redirecting to URL ${url}.`);
		document.location.href = url;
	}
}
